import {
  collection,
  getDocs,
  query,
  where,
  orderBy,
  doc,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase/config";

export const getWarningsForUser = async (userId, userRole) => {
  // const newRoles = userRole + "s";

  if (!userId || !userRole) {
    throw new Error("Invalid input: userId and userRole are required.");
  }

  try {
    const q = query(
      collection(db, "warnings"),
      where("receiverId", "==", userId),
      where("role", "==", userRole),
      orderBy("createdAt", "desc")
    );

    const querySnapshot = await getDocs(q);
    const warnings = [];

    querySnapshot.forEach((doc) => {
      warnings.push({
        id: doc.id,
        ...doc.data(),
      });
    });

    return warnings;
  } catch (error) {
    console.error("Error fetching warnings: ", error);
    throw error;
  }
};

export const getAllWarnings = async () => {
  try {
    const q = query(collection(db, "warnings"), orderBy("createdAt", "desc"));

    const querySnapshot = await getDocs(q);
    const warnings = [];

    querySnapshot.forEach((doc) => {
      warnings.push({
        id: doc.id,
        ...doc.data(),
      });
    });

    return warnings;
  } catch (error) {
    console.error("Error fetching all warnings: ", error);
    throw error;
  }
};

export const markWarningAsRead = async (warningId) => {
  try {
    const warningRef = doc(db, "warnings", warningId);
    await updateDoc(warningRef, {
      isRead: true,
      readAt: serverTimestamp(),
    });
  } catch (error) {
    console.error("Error marking warning as read: ", error);
    throw error;
  }
};

export const getUnreadWarningsCount = async (userId, userRole) => {
  try {
    const q = query(
      collection(db, "warnings"),
      where("receiverId", "==", userId),
      where("role", "==", userRole),
      where("isRead", "==", false)
    );

    const querySnapshot = await getDocs(q);
    return querySnapshot.size;
  } catch (error) {
    console.error("Error getting unread count: ", error);
    return 0;
  }
};
